import React, { useEffect, useState } from 'react';
import {
  Input,
  Radio,
  Row,
  Col,
  Select,
  Form,
  Button,
  Progress,
  message
} from 'antd';
import styles from '../styles.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
// import downloadIcon from '@/common/assets/images/DownloadIcon.svg';
// import EditIcon from '@/common/assets/images/EditIcon.svg';
import { DeleteOutlined } from '@ant-design/icons';

import { createFamilyDetails, deleteBrotherAPI } from '../../redux/slice';
import { event } from '../../../../utilities/gtag';
const Edit = ({
  family_Status,
  family_Value,
  family_Type,
  Occupation_Data,
  siblings_maritialStatus,
  user_data,
  education_list
}) => {
  console.log('user_data', user_data);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { createFamilyDetailsloading } = useSelector(
    (state) => state.Editfamily
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [familyStatus, setFamilyStatus] = useState();
  const [familyValue, setFamilyValue] = useState();
  const [familyType, setFamilyType] = useState();
  const [brothers, setBrothers] = useState([0]);
  const [sisters, setSisters] = useState([0]);

  console.log('Profile_ID:', params.id);

  const onFinish = async (values) => {
    event({
      action: 'profile_creation', // event name
      category: 'Family Creation',
      label: 'Profile Form Submitted',
      value: 1
    });
    console.log('Edit_Family_details', values);

    const payload = {
      profile_id: params.id,
      family_status_id: values.family_status_id,
      family_type_id: values.family_type_id,
      family_values_id: values.family_values_id,
      user_mother_details: [
        {
          parent_name: values.mother_name,
          occupation_id: values.mother_occupation,
          residing_city: values.mother_residing_city,
          home_town: values.mother_hometown,
          higher_education_id: values.mother_education
        }
      ],
      user_father_details: [
        {
          parent_name: values.father_name,
          occupation_id: values.father_occupation,
          residing_city: values.father_residing_city,
          home_town: values.father_hometown,
          higher_education_id: values.fathers_education
        }
      ],
      user_brother_details:
        values.brothers?.map((brother) => ({
          id: brother.id || null, // Include id if available, otherwise null
          sibling_name: brother.sibling_name, // ✅ Use correct property
          marital_status_id: brother.marital_status_id // ✅ Use correct property
        })) || [],

      // Map Sister Details
      user_sister_details:
        values.sisters?.map((sister) => ({
          id: sister.id || null, // Include id if available, otherwise null
          sibling_name: sister.sibling_name,
          marital_status_id: sister.marital_status_id
        })) || []
    };

    console.log('Payload_familyDetails', payload);
    try {
      console.log('Form Submitted:', payload);
      const response = await dispatch(createFamilyDetails(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        // localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        // navigate(`/editeducation/${response.profile_id}`); // Redirect on success
        message.success(response.message || 'Form submitted successfully!');
        navigate(`/editeducation`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }
  };

  // Tabs Data //
  const routes = {
    'About Me': '/editprofile',
    'Family Details': '/editfamily',
    'Education & Career': '/editeducation',
    Horoscope: '/edithoroscope',
    Contact: '/editcontact',
    'Desired Partner': '/editpartner',
    Membership: '/membership_payment'
  };
  const handleSectionClick = (section) => {
    if (routes[section]) {
      navigate(routes[section]);
    }
  };
  const activeTab = Object.entries(routes).find(
    ([, path]) => location.pathname === path
  )?.[0];

  // Tabs Data

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userName =
    matUserObject.user_details.first_name +
    ' ' +
    matUserObject.user_details.last_name;

  useEffect(() => {
    if (user_data?.Profiles?.[0]) {
      const profile = user_data?.Profiles?.[0];
      const parents = profile?.ProfileFamilies || [];

      const mother =
        parents.find((parent) => parent.parent_type === 'mother')
          ?.parent_name || null;
      const mother_residing_city =
        parents.find((parent) => parent.parent_type === 'mother')
          ?.residing_city || null;
      const mother_home_town =
        parents.find((parent) => parent.parent_type === 'mother')?.home_town ||
        null;
      const mother_occupation =
        parents.find((parent) => parent.parent_type === 'mother')?.Occupation
          ?.id || null;
      const mother_education =
        parents.find((parent) => parent.parent_type === 'mother')
          ?.HigherEducation?.id || null;

      // mother_education, fathers_education

      const father =
        parents.find((parent) => parent.parent_type === 'father')
          ?.parent_name || null;
      const father_residing_city =
        parents.find((parent) => parent.parent_type === 'father')
          ?.residing_city || null;
      const father_home_town =
        parents.find((parent) => parent.parent_type === 'father')?.home_town ||
        null;
      const father_occupation =
        parents.find((parent) => parent.parent_type === 'father')?.Occupation
          ?.id || null;
      const fathers_education =
        parents.find((parent) => parent.parent_type === 'father')
          ?.HigherEducation?.id || null;

      const mapSiblings = (siblings) => {
        return siblings.map((sibling) => ({
          id: sibling?.id || null,
          sibling_name: sibling?.sibling_name || '',
          marital_status_id: sibling?.MaritalStatus?.id || null
        }));
      };

      let brothers = mapSiblings(
        profile?.ProfileSiblings?.filter(
          (sibling) => sibling.sibling_type === 'brother'
        ) || null
      );

      if (brothers.length === 0) {
        brothers = [{ id: null, sibling_name: '', marital_status_id: null }];
      }

      let sisters = mapSiblings(
        profile?.ProfileSiblings?.filter(
          (sibling) => sibling.sibling_type === 'sister'
        ) || null
      );

      if (sisters.length === 0) {
        sisters = [{ id: null, sibling_name: '', marital_status_id: null }];
      }

      console.log('Family Status ID:', profile?.FamilyStatus?.id);
      setFamilyStatus(Number(profile?.FamilyStatus?.id));
      setFamilyValue(Number(profile?.FamilyValue?.id));
      setFamilyType(Number(profile?.FamilyType?.id));

      form.setFieldsValue({
        mother_name: mother || '',
        mother_residing_city: mother_residing_city || '',
        mother_hometown: mother_home_town || '',
        mother_occupation: mother_occupation || null,
        mother_education: mother_education || null,
        father_name: father || '',
        father_residing_city: father_residing_city || '',
        father_hometown: father_home_town || '',
        father_occupation: father_occupation || null,
        fathers_education: fathers_education || null,
        brothers,
        sisters,
        family_status_id: profile?.FamilyStatus?.id || null,
        family_values_id: profile?.FamilyValue?.id || null,
        family_type_id: profile?.FamilyType?.id || null
      });
      setBrothers(brothers);
      setSisters(sisters);
    }
  }, [user_data]);

  const handleFamilyStatus = (value) => {
    console.log('handle_FamilyStatus', value);
    setFamilyStatus(value);
  };

  const handleFamilyValue = (value) => {
    console.log('handle_FamilyValue', value);
    setFamilyValue(value);
  };

  const handleFamilyType = (id) => {
    console.log('handle_FamilyType', id);
    setFamilyType(id);
  };

  // const addBrother = () => {
  //   // setBrothers([...brothers, { sibling_name: '', marital_status_id: '' }]);
  //   setBrothers((prevBrothers) => [
  //     ...prevBrothers,
  //     { id: null, sibling_name: '', marital_status_id: null }
  //   ]);
  // };

  const handleBrotherChange = (index, field, value) => {
    setBrothers((prevBrothers) => {
      const updatedBrothers = [...prevBrothers];
      updatedBrothers[index] = { ...updatedBrothers[index], [field]: value };

      // Sync with form fields
      form.setFieldsValue({ brothers: updatedBrothers });

      return updatedBrothers;
    });
  };
  console.log('updatedBrothers', brothers);

  const addBrother = () => {
    setBrothers((prevBrothers) => {
      const updatedBrothers = [
        ...prevBrothers,
        { id: null, sibling_name: '', marital_status_id: null } // New row
      ];

      // Preserve existing values in form
      const existingFormValues = form.getFieldValue('brothers') || [];
      form.setFieldsValue({
        brothers: [
          ...existingFormValues,
          { id: null, sibling_name: '', marital_status_id: null }
        ]
      });

      return updatedBrothers;
    });
  };

  console.log('setBrothers', brothers);

  const removeBrother = async (index) => {
    const removedBrother = brothers[index];
    console.log('Removed Brother', index);
    const updatedBrothers = brothers.filter((_, i) => i !== index);
    setBrothers(updatedBrothers);
    form.setFieldsValue({ brothers: updatedBrothers });

    console.log('removedBrother.id', removedBrother.id);
    if (removedBrother?.id) {
      try {
        let payload = {
          id: removedBrother.id
        };
        await dispatch(deleteBrotherAPI(payload)).unwrap();
        console.log('Brother deleted successfully!');
      } catch (error) {
        console.error('Error deleting brother:', error);
      }
    }
  };

  const handleSisterChange = (index, field, value) => {
    setSisters((prevSisters) => {
      const updatedSisters = [...prevSisters];
      updatedSisters[index] = { ...updatedSisters[index], [field]: value };

      // Sync with form fields
      form.setFieldsValue({ sisters: updatedSisters });

      return updatedSisters;
    });
  };

  const addSister = () => {
    // setSisters([...sisters, sisters.length]);
    setSisters((prevSisters) => [
      ...prevSisters,
      { id: null, sibling_name: '', marital_status_id: null }
    ]);
  };

  const removeSister = async (index) => {
    const removeSister = sisters[index];
    const updatedSisters = sisters.filter((_, i) => i !== index);
    setSisters(updatedSisters);
    form.setFieldsValue({ sisters: updatedSisters });

    console.log('removeSister.id', removeSister.id);
    if (removeSister?.id) {
      try {
        let payload = {
          id: removeSister.id
        };
        await dispatch(deleteBrotherAPI(payload)).unwrap();
        console.log('Brother deleted successfully!');
      } catch (error) {
        console.error('Error deleting brother:', error);
      }
    }
  };

  const percent = user_data?.user_score;
  // const conicColors = {
  //   '0%': '#87d068',
  //   '50%': '#ffe58f',
  //   '100%': '#ffccc7'
  // };
  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };
  // const profile_unique_id = matUserObject?.user_details?.profile_unique_id;

  return (
    <div className={styles.maincontainer}>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <div className={styles.editOuter}>
          <div className={styles.singleContainer}>
            <Row
              gutter={24}
              style={{ width: '100%' }}
              className={styles.aboutimgstyles}
            >
              <Col
                xl={7}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className={styles.leftspace}
              >
                <div className={styles.leftimgcontainer}>
                  {/* <img src={LeftImg} /> */}
                  <div className={styles.overlayText}>
                    <h2 className={styles.title}>THE TALE OF</h2>
                    <h1 className={styles.bigTitle}>TWO</h1>
                  </div>
                </div>
              </Col>
              <Col
                xl={16}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className={styles.leftspace}
              >
                <div className={styles.detailSide}>
                  <div className={styles.detailName}>
                    <div className={styles.nameflex}>
                      <div className={styles.idname}>
                        <h1 className={styles.dName}> {userName} </h1>
                        {/* <span> {profile_unique_id} </span> */}
                      </div>
                      {/* <div className={styles.matchpercent}>
                        <h6>
                          <span>96%</span> Away to find the right match
                        </h6>
                      </div> */}
                      <Row gutter={[8, 8]} wrap>
                        <Col className={styles.progressname}>
                          <Progress
                            size="small"
                            type="circle"
                            percent={percent}
                            // strokeColor={conicColors}
                            strokeColor={getStrokeColor(percent)}
                          />
                          <h6 className={styles.matchpercent}>
                            away to find your life partner
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    <div className={styles.changes}>
                      {/* <div className={styles.textContainer}>
                        <img
                          src={EditIcon}
                          alt="Edit Profile"
                          className={styles.icon}
                          onClick={handleEditClick}
                        />
                        <div>Edit</div>
                      </div> */}

                      {/* <div className={styles.vBorder}></div>

                      <div className={styles.textContainer}>
                        <img
                          src={downloadIcon}
                          alt="Download Profile"
                          className={styles.icon}
                        />
                        <div>Download</div>
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <div className={styles.detailsOuter}>
                      <div className={styles.detailsInner}>
                        <div className={styles.detailsInside}>
                          {/* Tabs Content */}
                          <div className={styles.searchTab}>
                            {Object.keys(routes).map((section) => (
                              <div
                                key={section}
                                className={`${styles.searchTabHeader} ${
                                  activeTab === section ? styles.activeTab : ''
                                }`}
                                onClick={() => handleSectionClick(section)}
                              >
                                {section}
                              </div>
                            ))}
                          </div>
                          {/* Tabs Content */}
                          <div>
                            {/** one  */}
                            <div className={styles.personalOne}>
                              <div className={styles.personalCol}>
                                <div>
                                  <div className={styles.ageRangeContainer}>
                                    <Form.Item
                                      label="Family Status"
                                      name="family_status_id"
                                      rules={[
                                        {
                                          required: false,
                                          message: 'Please select family status'
                                        }
                                      ]}
                                    >
                                      <div className={styles.personalTwo}>
                                        <div className={styles.checkboxOuter}>
                                          <div
                                            className={styles.checkboxInside}
                                          >
                                            <Radio.Group
                                              value={familyStatus}
                                              onChange={(e) =>
                                                handleFamilyStatus(
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <Row
                                                gutter={[24]}
                                                className={styles.radiobuttons}
                                              >
                                                {family_Status?.length
                                                  ? family_Status.map(
                                                      (fstatus, index) => (
                                                        <Col
                                                          xl={6}
                                                          lg={6}
                                                          md={6}
                                                          sm={24}
                                                          xs={24}
                                                          key={index}
                                                        >
                                                          <Radio
                                                            value={fstatus.id}
                                                          >
                                                            {fstatus.status}
                                                          </Radio>
                                                        </Col>
                                                      )
                                                    )
                                                  : null}
                                              </Row>
                                            </Radio.Group>
                                          </div>
                                        </div>
                                      </div>
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/** two */}
                            <div className={styles.personalOne}>
                              <div className={styles.personalCol}>
                                <div>
                                  <div className={styles.ageRangeContainer}>
                                    <Form.Item
                                      label="Family Values"
                                      name="family_values_id"
                                      rules={[
                                        {
                                          required: false,
                                          message: 'Please select family values'
                                        }
                                      ]}
                                    >
                                      <div className={styles.personalTwo}>
                                        <div className={styles.checkboxOuter}>
                                          <div
                                            className={styles.checkboxInside}
                                          >
                                            {/* <Radio.Group> */}
                                            <Radio.Group
                                              value={familyValue}
                                              onChange={(e) =>
                                                handleFamilyValue(
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <Row
                                                gutter={[24]}
                                                className={styles.radiobuttons}
                                              >
                                                {family_Value?.length
                                                  ? family_Value.map(
                                                      (fvalue, index) => (
                                                        <Col
                                                          xl={6}
                                                          lg={6}
                                                          md={6}
                                                          sm={24}
                                                          xs={24}
                                                          key={index}
                                                        >
                                                          <Radio
                                                            value={fvalue.id}
                                                          >
                                                            {fvalue.values}
                                                          </Radio>
                                                        </Col>
                                                      )
                                                    )
                                                  : null}
                                              </Row>
                                            </Radio.Group>
                                          </div>
                                        </div>
                                      </div>
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/**three */}
                            <div className={styles.personalOne}>
                              <div className={styles.countryRangeContainer}>
                                {/* <label className={styles.ageLabel}>
                              Family Type
                            </label> */}
                                <Form.Item
                                  label="Family Type"
                                  name="family_type_id"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please select family type'
                                    }
                                  ]}
                                >
                                  <div
                                    // style={{
                                    //   display: 'flex',
                                    //   gap: '9px',
                                    //   paddingTop: '5px'
                                    // }}
                                    className={styles.famdetails}
                                  >
                                    <div
                                      className={styles.selectContainerCountry}
                                    >
                                      <div className={styles.checkboxFamily}>
                                        <div className={styles.familyInner}>
                                          {/* <Radio.Group> */}
                                          <Radio.Group
                                            value={familyType}
                                            onChange={(e) =>
                                              handleFamilyType(e.target.value)
                                            }
                                          >
                                            <Row
                                              gutter={[24]}
                                              className={
                                                styles.radiofamilytypebutton
                                              }
                                            >
                                              {family_Type?.length
                                                ? family_Type.map(
                                                    (ftype, index) => (
                                                      <Col
                                                        xl={6}
                                                        lg={6}
                                                        md={6}
                                                        sm={12}
                                                        xs={12}
                                                        key={index}
                                                      >
                                                        <Radio value={ftype.id}>
                                                          {ftype.type}
                                                        </Radio>
                                                      </Col>
                                                    )
                                                  )
                                                : null}
                                            </Row>
                                          </Radio.Group>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Form.Item>
                              </div>
                            </div>

                            {/** four header */}
                            <div className={styles.thirdHeading}>
                              MOTHER`S DETAILS
                            </div>

                            {/** four */}
                            <div className={styles.personalOne}>
                              <div
                                // style={{
                                //   display: 'flex',
                                //   gap: '15px',
                                //   alignItems: 'center'
                                // }}
                                className={styles.motherdetails}
                              >
                                {/* Mother's Name Input */}
                                <div
                                  // style={{
                                  //   display: 'flex',
                                  //   flexDirection: 'column',
                                  //   width: '75%'
                                  // }}
                                  className={styles.motherName}
                                >
                                  <Form.Item
                                    label="Mother’s Name"
                                    name="mother_name"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Mother's name is required"
                                      }
                                    ]}
                                  >
                                    <Input
                                      className={styles.customInput}
                                      placeholder="Enter mother's name"
                                      // disabled={isMother && !isEdit}
                                    />
                                  </Form.Item>
                                </div>

                                {/* Occupation Select */}

                                <div
                                  // style={{
                                  //   display: 'flex',
                                  //   flexDirection: 'column',
                                  //   width: '25%'
                                  // }}
                                  className={styles.motherOccupation}
                                >
                                  <div className={styles.selectContainer}>
                                    <Form.Item
                                      label="Occupation"
                                      name="mother_occupation"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Mother occupation required'
                                        }
                                      ]}
                                    >
                                      <Select
                                        placeholder="Select occupation"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      >
                                        {Occupation_Data?.length
                                          ? Occupation_Data?.map(
                                              (Occupation, index) => {
                                                return (
                                                  <option
                                                    value={Occupation?.id}
                                                    key={index}
                                                  >
                                                    {Occupation?.occupation}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                              <div className={styles.edudetails}>
                                {/* Higher Education */}
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                  }}
                                >
                                  <Form.Item
                                    label="Highest Education"
                                    name="mother_education"
                                    rules={[
                                      {
                                        required: false,
                                        message: 'Mother Education required'
                                      }
                                    ]}
                                  >
                                    <Select
                                      // placeholder="Select a Degree"
                                      placeholder="Select mother`s highest degree"
                                      className={styles.select}
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option?.children
                                          ?.toLowerCase()
                                          ?.includes(input.toLowerCase())
                                      }
                                    >
                                      {education_list?.map((list) => (
                                        <Select.Option
                                          key={list.id}
                                          value={list.id}
                                        >
                                          {list.higher_education}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                  }}
                                >
                                  <Form.Item
                                    label="Residing City"
                                    name="mother_residing_city"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Residing city is required'
                                      }
                                    ]}
                                  >
                                    <Input
                                      className={styles.customInputCity}
                                      placeholder="Enter residing city"
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                  }}
                                >
                                  <Form.Item
                                    label="Home Town"
                                    name="mother_hometown"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Home town is required'
                                      }
                                    ]}
                                  >
                                    <Input
                                      className={styles.customInputCity}
                                      placeholder="Enter home town"
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </div>

                            {/** five header */}
                            <div className={styles.thirdHeading}>
                              FATHER`S DETAILS
                            </div>
                            {/** five */}
                            <div className={styles.personalOne}>
                              <div
                                // style={{
                                //   display: 'flex',
                                //   gap: '15px',
                                //   alignItems: 'center'
                                // }}
                                className={styles.motherdetails}
                              >
                                {/* Father's Name Input */}
                                <div
                                  // style={{
                                  //   display: 'flex',
                                  //   flexDirection: 'column',
                                  //   width: '75%'
                                  // }}
                                  className={styles.motherName}
                                >
                                  <Form.Item
                                    label="Father’s Name"
                                    name="father_name"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Father's name is required"
                                      }
                                    ]}
                                  >
                                    <Input
                                      className={styles.customInput}
                                      placeholder="Enter father’s name"
                                    />
                                  </Form.Item>
                                </div>

                                {/* Occupation Select */}

                                <div
                                  // style={{
                                  //   display: 'flex',
                                  //   flexDirection: 'column',
                                  //   width: '25%'
                                  // }}
                                  className={styles.motherOccupation}
                                >
                                  <div className={styles.selectContainer}>
                                    <Form.Item
                                      label="Occupation"
                                      name="father_occupation"
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Father's occupation is required"
                                        }
                                      ]}
                                    >
                                      <Select
                                        placeholder="Select occupation"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      >
                                        {Occupation_Data?.length
                                          ? Occupation_Data?.map(
                                              (Occupation, index) => {
                                                return (
                                                  <option
                                                    value={Occupation?.id}
                                                    key={index}
                                                  >
                                                    {Occupation?.occupation}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                              <div className={styles.edudetails}>
                                {/* Higher Education */}
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                  }}
                                >
                                  <Form.Item
                                    label="Highest Education"
                                    name="fathers_education"
                                    rules={[
                                      {
                                        required: false,
                                        message: 'Father`s Education required'
                                      }
                                    ]}
                                  >
                                    <Select
                                      // placeholder="Select a Degree"
                                      placeholder="Select father`s highest degree"
                                      className={styles.select}
                                      showSearch
                                      optionFilterProp="children"
                                      filterOption={(input, option) =>
                                        option?.children
                                          ?.toLowerCase()
                                          ?.includes(input.toLowerCase())
                                      }
                                    >
                                      {education_list?.map((list) => (
                                        <Select.Option
                                          key={list.id}
                                          value={list.id}
                                        >
                                          {list.higher_education}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                  }}
                                >
                                  <Form.Item
                                    label="Residing City"
                                    name="father_residing_city"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Residing city is required'
                                      }
                                    ]}
                                  >
                                    <Input
                                      className={styles.customInputCity}
                                      placeholder="Enter residing city"
                                    />
                                  </Form.Item>
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                  }}
                                >
                                  <Form.Item
                                    label="Home Town"
                                    name="father_hometown"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Home town is required'
                                      }
                                    ]}
                                  >
                                    <Input
                                      className={styles.customInputCity}
                                      placeholder="Enter home town"
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </div>

                            {/** six  header */}
                            <div className={styles.thirdHeading}>
                              SIBLING`S DETAILS
                            </div>
                            {/** six */}
                            <div className={styles.personalOne}>
                              <div>
                                {brothers.length > 0 &&
                                  brothers.map((brother, index) => (
                                    <div
                                      key={index}
                                      // style={{
                                      //   display: 'flex',
                                      //   gap: '15px',
                                      //   alignItems: 'center'
                                      //   // marginBottom: '10px'
                                      // }}
                                      className={styles.brotherdetails}
                                    >
                                      {/* Hidden Field for Brother's ID */}
                                      <Form.Item
                                        name={['brothers', index, 'id']}
                                        initialValue={brother?.id || null}
                                        hidden
                                      >
                                        <Input />
                                      </Form.Item>
                                      {/* Brother's Name */}
                                      <div
                                        style={{ flex: 3 }}
                                        className={styles.brotherName}
                                      >
                                        <Form.Item
                                          label={`Brother's Name`}
                                          name={[
                                            'brothers',
                                            index,
                                            'sibling_name'
                                          ]}
                                          rules={[
                                            {
                                              required: false,
                                              message:
                                                "Please enter brother's name!"
                                            }
                                          ]}
                                        >
                                          <Input
                                            placeholder="Enter brother's name"
                                            value={brother.sibling_name}
                                            onChange={(e) =>
                                              handleBrotherChange(
                                                index,
                                                'sibling_name',
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </div>

                                      {/* Brother's Marital Status */}
                                      <div
                                        style={{ flex: 2 }}
                                        className={styles.brotherMarital}
                                      >
                                        <Form.Item
                                          label={`Brother's Marital Status`}
                                          name={[
                                            'brothers',
                                            index,
                                            'marital_status_id'
                                          ]}
                                          rules={[
                                            {
                                              required: false,
                                              message:
                                                "Please select brother's marital status!"
                                            }
                                          ]}
                                        >
                                          <Select
                                            placeholder="Select marital status"
                                            value={brother.marital_status_id} // Ensure value is set
                                            onChange={(value) =>
                                              handleBrotherChange(
                                                index,
                                                'marital_status_id',
                                                value
                                              )
                                            }
                                          >
                                            {siblings_maritialStatus?.map(
                                              (sms) => (
                                                <Select.Option
                                                  key={sms.id}
                                                  value={sms.id}
                                                >
                                                  {sms.marital_status}
                                                </Select.Option>
                                              )
                                            )}
                                          </Select>
                                        </Form.Item>
                                      </div>

                                      {/* Delete Button (Only show if more than 1) */}
                                      {brothers.length > 1 && (
                                        <DeleteOutlined
                                          onClick={() => removeBrother(index)}
                                          className={styles.deleteIcon}
                                        />
                                      )}
                                    </div>
                                  ))}
                                {/* Add Button */}
                                <div
                                  onClick={addBrother}
                                  className={styles.addDegree}
                                >
                                  + Add Brother
                                </div>
                              </div>
                              {/* Brother Details added */}
                              <br />
                              {/* Siste Details added */}
                              <div>
                                {/* {sisters.map((sisterIndex, index) => ( */}
                                {sisters.length > 0 &&
                                  sisters.map((sister, index) => (
                                    <div
                                      // key={sisterIndex}
                                      key={sister?.id || index}
                                      // style={{
                                      //   display: 'flex',
                                      //   gap: '15px',
                                      //   alignItems: 'center'
                                      //   // marginBottom: '10px'
                                      // }}
                                      className={styles.brotherdetails}
                                    >
                                      {/* Hidden Field for Sister's ID */}
                                      <Form.Item
                                        name={['sisters', index, 'id']}
                                        initialValue={sister?.id || null} // Send id for edit, null for new
                                        hidden
                                      >
                                        <Input />
                                      </Form.Item>
                                      {/* Sister's Name */}
                                      <div
                                        style={{ flex: 3 }}
                                        className={styles.brotherName}
                                      >
                                        <Form.Item
                                          label={`Sister's Name`}
                                          name={[
                                            'sisters',
                                            index,
                                            'sibling_name'
                                          ]}
                                          rules={[
                                            {
                                              required: false,
                                              message:
                                                "Please enter sister's name!"
                                            }
                                          ]}
                                        >
                                          <Input
                                            placeholder="Enter sister's name"
                                            value={sister.sibling_name} // Ensure value is set
                                            onChange={(e) =>
                                              handleSisterChange(
                                                index,
                                                'sibling_name',
                                                e.target.value
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </div>

                                      {/* Sister's Marital Status */}
                                      <div
                                        style={{ flex: 2 }}
                                        className={styles.brotherMarital}
                                      >
                                        <Form.Item
                                          label={`Sister's Marital Status`}
                                          name={[
                                            'sisters',
                                            index,
                                            'marital_status_id'
                                          ]}
                                          rules={[
                                            {
                                              required: false,
                                              message:
                                                "Please select sister's marital status!"
                                            }
                                          ]}
                                        >
                                          <Select
                                            placeholder="Select marital Status"
                                            value={sister.marital_status_id} // Ensure value is set
                                            onChange={(value) =>
                                              handleSisterChange(
                                                index,
                                                'marital_status_id',
                                                value
                                              )
                                            }
                                          >
                                            {siblings_maritialStatus?.map(
                                              (sms) => (
                                                <Select.Option
                                                  key={sms.id}
                                                  value={sms.id}
                                                >
                                                  {sms.marital_status}
                                                </Select.Option>
                                              )
                                            )}
                                          </Select>
                                        </Form.Item>
                                      </div>

                                      {/* Delete Button (Only show if more than 1) */}
                                      {sisters.length > 1 && (
                                        <DeleteOutlined
                                          onClick={() => removeSister(index)}
                                          className={styles.deleteIcon}
                                        />
                                      )}
                                    </div>
                                  ))}

                                {/* Add Button */}
                                <div
                                  onClick={addSister}
                                  className={styles.addDegree}
                                >
                                  {/* ➕ Add Sister */}+ Add Sister
                                </div>
                              </div>
                            </div>
                            <Form.Item>
                              <Button
                                type="primary"
                                htmlType="submit"
                                className={styles.submitbutton}
                                loading={createFamilyDetailsloading}
                                disabled={createFamilyDetailsloading}
                              >
                                Save & Next
                              </Button>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Edit;
